package com.anjuros.website.redesign.sections.home

import androidx.compose.runtime.Composable
import com.anjuros.website.redesign.components.RdFaqBand
import com.anjuros.website.redesign.util.RdText

/** Questions and answers shown on the homepage; also used for the FAQPage structured data. */
val HomeFaqs = listOf(
    RdText.HOME_FAQ1_Q to RdText.HOME_FAQ1_A,
    RdText.HOME_FAQ2_Q to RdText.HOME_FAQ2_A,
    RdText.HOME_FAQ3_Q to RdText.HOME_FAQ3_A,
    RdText.HOME_FAQ4_Q to RdText.HOME_FAQ4_A,
    RdText.HOME_FAQ5_Q to RdText.HOME_FAQ5_A,
)

@Composable
fun HomeFaqSection() {
    RdFaqBand(RdText.HOME_FAQ_TITLE, HomeFaqs)
}
